import { TYPES } from "./draft_dialog.type";

const initState = {
  draftDialogAll: null,
  draftDialogDetail: null,
  draftDialogOpenAdd: false,
  draftDialogOpenEdit: false,
  draftDialogSelected: null,
  draftDialogSearch: "",
  // review.
  draftDialogSecond: 0,
  draftDialogPlay: false,
  draftDialogIndex: 0,
  //
  draftDialogAudioUrl: null,
  //
  draftDialogSelectedRange: {
    start: 0,
    end: 0,
  },
  //
  draftDialogRentTask: 0,
};

const draftDialogReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DRAFT_DIALOG_AUDIO_URL:
      return {
        ...state,
        draftDialogAudioUrl: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_DETAIL:
      return {
        ...state,
        draftDialogDetail: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_ALL:
      return {
        ...state,
        draftDialogAll: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_ADD:
      return {
        ...state,
        draftDialogOpenAdd: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_EDIT:
      return {
        ...state,
        draftDialogOpenEdit: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SELECTED:
      return {
        ...state,
        draftDialogSelected: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SEARCH:
      return {
        ...state,
        draftDialogSearch: payload,
      };

    //
    case TYPES.SET_DRAFT_DIALOG_PLAY:
      return {
        ...state,
        draftDialogPlay: payload,
      };
    case TYPES.SET_DRAFT_DIALOG_INDEX:
      return {
        ...state,
        draftDialogIndex: payload,
      };
    case TYPES.SET_DRAFT_DIALOG_SECOND:
      return {
        ...state,
        draftDialogSecond: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_RENT_TASK:
      return {
        ...state,
        draftDialogRentTask: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SELECTED_RANGE:
      return {
        ...state,
        draftDialogSelectedRange: payload,
      };

    default:
      return state;
  }
};

export default draftDialogReducer;
